import React from 'react';
import classnames from 'classnames';
import { StatusTip, StatusTipProps } from 'tea-component';
import { CONSTANT_TEXTS } from '@gp/constants/const';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

export interface IDBGStatusTipProps extends IBaseProps, StatusTipProps {}

const DBGStatusTip: React.FC<IDBGStatusTipProps> = (props) => {
  const {
    style,
    className,
    status,
    hideIcon = false,
    loadingText = 'Loading...',
    emptyText = CONSTANT_TEXTS.EMPTY_TEXT,
    errorText = CONSTANT_TEXTS.SORRY_EMPTY_TEXT,
    retryText = 'Retry',
    ...restProps
  } = props;

  return (
    <StatusTip
      {...restProps}
      style={style}
      className={classnames('dbg-common-status-tip', className)}
      status={status}
      hideIcon={status === 'error' ? true : hideIcon}
      loadingText={loadingText}
      emptyText={emptyText}
      errorText={errorText}
      retryText={retryText}
    />
  );
};

export default DBGStatusTip;
